module.exports = __webpack_public_path__ + "static/banner-234c64da1fc008fe1c2eb2ae50271484.jpg";